import { __extends } from "tslib";
import React from 'react';
import { AppBarRenderError } from './AppBarRenderError';
var AppBarErrorBoundary = /** @class */ (function (_super) {
    __extends(AppBarErrorBoundary, _super);
    function AppBarErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    AppBarErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo,
        });
    };
    AppBarErrorBoundary.prototype.render = function () {
        return this.state.hasError ? (React.createElement(AppBarRenderError, { error: this.state.error, errorInfo: this.state.errorInfo })) : (this.props.children);
    };
    return AppBarErrorBoundary;
}(React.Component));
export { AppBarErrorBoundary };
//# sourceMappingURL=AppBarErrorBoundary.js.map